import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview as ImprintsOverview } from 'domains/MediaPlatforms/Settings/Legal/Imprints'
import { Overview as PrivacyOverview } from 'domains/MediaPlatforms/Settings/Legal/Privacy'
import { Overview as TermsOverview } from 'domains/MediaPlatforms/Settings/Legal/Terms'
import { mediaPlatformSettingsLayoutRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'

export const mediaPlatformSettingsLegalRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLayoutRoute,
  path: StaticRouteParameter.LEGAL,
  loader: () => null,
})

export const mediaPlatformSettingsLegalPrivacyOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLegalRoute,
  path: '/',
  component: PrivacyOverview,
})

export const mediaPlatformSettingsLegalImprintsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLegalRoute,
  path: StaticRouteParameter.IMPRINTS,
  component: ImprintsOverview,
})

export const mediaPlatformSettingsLegalTermsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLegalRoute,
  path: StaticRouteParameter.TERMS,
  component: TermsOverview,
})
